import { useTranslation } from "react-i18next";
import { useBasicComponents } from "./useBasicComponent";
import { AIOpsVariablesEditableTable } from "@/components/instance/config/AIOpsVariablesEditableTable";
import { ReadOnlyInput } from "@/components/instance/config/ReadOnlyInput";

export const useAIOpsConfig = (ver) => {
  const { t } = useTranslation();
  const { replicasReadOnly, core, memory, dataDisk, nodegroup } = useBasicComponents();

  const version = (group) => ({
    title: t("config.instance.form.version", "Version"),
    dataIndex: `${group}.version`,
    width: "sm",
    renderFormItem: () => {
      return <ReadOnlyInput value={ver} />;
    },
    fieldProps: {
      readOnly: true,
    },
  });

  const aiopsColumns = () => {
    const group = "aiops";
    return [
      // Editable at create time only: AIOps has no Update form (useAIOpsConfig is only used by
      // the create wizard), so there is no live-migrate path -- AIOpsHelm.overrideValues()
      // reads this at deploy time, same as Neo4j/Gitea/MySQL, but there is no update_more()
      // counterpart since nothing ever calls it.
      nodegroup({ group }),
      replicasReadOnly({ group }),
      core({ group }),
      memory({ group }),
      version({ group }),
      dataDisk({ group }),
    ];
  };

  const variablesColumns = () => {
    return [
      {
        dataIndex: "aiops.variables",
        renderFormItem: (item, _, form) => {
          return (
            <AIOpsVariablesEditableTable
              variablesValue={item.initialValue}
              onChange={(newVariables) => {
                const items = newVariables.reduce((acc, item) => {
                  if (item.overrideValue != "") {
                    acc.push({ name: item.name, value: item.overrideValue });
                  }
                  return acc;
                }, []);
                form.setFieldsValue({
                  [item.dataIndex]: items,
                });
              }}
            />
          );
        },
        formItemProps: {
          rules: [
            ({ getFieldValue }) => ({
              validator(_, value) {
                return Promise.resolve();
                // TODO: validation
                // if (!value || getFieldValue("password") === value) {
                //   return Promise.resolve();
                // }
                // return Promise.reject(
                //   new Error(
                //     t(
                //       "pages.login.errors.notmatch",
                //       "The two passwords do not match!",
                //     ),
                //   ),
                // );
              },
            }),
          ],
        },
        width: "m",
      },
    ];
  };

  const aiopsSchema = [
    {
      title: t("config.instance.form.aiopsInstaller", "AIOps Installer"),
      valueType: "group",
      columns: aiopsColumns(),
    },
    {
      title: t("config.instance.form.aiops", "AIOps"),
      valueType: "group",
      columns: variablesColumns(),
    },
  ];

  return aiopsSchema;
};
